<template>
  <div>
    <v-layout
      wrap
      justify-center>
      <v-flex
        xs12
        sm10
        md8
        lg6
        xl4>
        <v-list
          v-if="$store.state.partners.length > 0"
          subheader
          class="pt-5">
          <v-subheader>パートナーとの連携解除</v-subheader>

          <template v-for="user in $store.state.selectUsers">
            <v-list-item
              v-if="user.isPartner"
              :key="user.userId">
              <v-list-item-avatar>
                <v-img :src="user.pictureUrl" />
              </v-list-item-avatar>

              <v-list-item-content class="py-0">
                <v-list-item-title>
                  {{ user.displayName }}
                </v-list-item-title>
              </v-list-item-content>

              <v-btn
                color="error"
                outlined
                rounded
                @click="openUnlinkDialog(user);">
                連携を解除
              </v-btn>
            </v-list-item>
          </template>

          <p class="pt-3 px-5 text-right grey--text text--darken-1 text-size-3">
            パートナー連携数：
            <strong class="text-size-5">{{ $store.state.partners.length }}</strong>
            <strong class="text-size-4"> / {{ $store.state.profile.partnerUpperLimit }}</strong>
          </p>
        </v-list>

        <v-list subheader>
          <v-subheader>退会</v-subheader>

          <v-list-item>
            <v-list-item-content class="py-0">
              <v-list-item-title class="mb-1">
                ユーザデータ削除
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                登録した思い出も全て削除します
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-btn
              color="error"
              outlined
              rounded
              dark
              @click="checkUserDelete();">
              削除
            </v-btn>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>

    <!-- パートナーと連携解除をするダイアログ -->
    <v-dialog
      v-model="isOpenUnlinkDialog"
      width="600px">
      <v-card>
        <v-card-title class="text-size-5 pl-5">
          パートナー連携解除
        </v-card-title>
        <v-divider />

        <v-list-item class="mt-5 ml-5">
          <v-list-item-avatar size="50">
            <v-img
              :src="partner.pictureUrl"
              :alt="partner.displayName" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title> {{ partner.displayName }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-card-text class="pt-5">
          <v-row
            no-gutters
            justify="center"
            class="caption">
            <ul>
              <li>パートナーとの思い出は消えてしまいます</li>
              <li>事前にパートナーには連携解除することを伝えておきましょう</li>
            </ul>
          </v-row>
        </v-card-text>

        <v-card-actions class="mr-2">
          <div class="flex-grow-1" />
          <v-btn
            color="primary"
            text
            @click="isOpenUnlinkDialog = false;">
            キャンセル
          </v-btn>

          <v-btn
            color="error"
            text
            @click="unlinkPartner();">
            解除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ユーザ削除のダイアログ -->
    <v-dialog
      v-model="isUserDelete"
      width="600px">
      <v-card>
        <v-card-title class="text-size-5 pl-5">
          ユーザデータ削除
        </v-card-title>
        <v-divider />

        <v-card-text class="pt-4">
          <v-row
            no-gutters
            justify="center"
            class="caption text-left">
            <ul>
              <li>あなた自身が登録した思い出は消えてしまいます</li>
              <li>再度LINEログインすると使うことができます</li>
            </ul>
          </v-row>
        </v-card-text>

        <v-card-actions class="mr-2">
          <div class="flex-grow-1" />
          <v-btn
            color="primary"
            text
            @click="isUserDelete = false;">
            キャンセル
          </v-btn>

          <v-btn
            color="error"
            text
            @click="userDelete();">
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ユーザ削除後の最後のダイアログ -->
    <v-dialog
      v-model="isEndService"
      width="600px"
      persistent>
      <v-card class="py-3">
        <v-row justify="center">
          <v-card-title class="subtitle-1 text-center">
            ご利用ありがとうございました！
          </v-card-title>
        </v-row>
        <v-row
          justify="center"
          class="pb-10 pt-5">
          <UserDeleteIcon />
        </v-row>
      </v-card>
    </v-dialog>

    <!-- 連携解除中のロード画面 -->
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64" />
    </v-overlay>
  </div>
</template>

<script>
import UserDeleteIcon from '../SVGs/UserDeleteIcon';

import dataStore from '../../libs/dataStore';
import ga from '../../libs/ga';

export default {
  components: {
    UserDeleteIcon,
  },
  data() {
    return {
      overlay: false,
      isOpenUnlinkDialog: false,
      isUserDelete: false,
      isEndService: false,
      partner: {},
    };
  },
  methods: {
    openUnlinkDialog: function(partner) {
      this.partner = partner;
      this.isOpenUnlinkDialog = true;
    },
    unlinkPartner: async function() {
      ga.settings.unlinkPartner(this.$ga);

      this.overlay = true;
      this.isOpenUnlinkDialog = false;

      const success = await dataStore.deletePartner(
        this.$store.state.profile.lineId,
        this.partner.lineId,
        this.partner.userId
      );

      if (success) {
        localStorage.setItem('unlinkSnackbar', true);
        location.href = '/trip';
      } else {
        this.overlay = false;
        this.$store.dispatch('showSnackbar', {
          ga: this.$ga,
          snackbar: {
            color: 'error',
            text: '連携解除に失敗しました',
          },
        });
      }
    },
    checkUserDelete: function() {
      if (this.$store.state.partners.length > 0) {
        this.$store.dispatch('showSnackbar', {
          ga: this.$ga,
          snackbar: {
            color: 'warning',
            text: '先にパートナーとの連携解除を行ってください',
          },
        });
      } else {
        this.isUserDelete = true;
      }
    },
    userDelete: async function() {
      ga.settings.userDelete(this.$ga);

      this.overlay = true;
      this.isUserDelete = false;

      const success = await dataStore.deleteUser(this.$store.state.profile.lineId);

      if (success) {
        document.cookie = 'tripholders-token=; max-age=0';
        this.isEndService = true;
      } else {
        this.overlay = false;
        this.$store.dispatch('showSnackbar', {
          ga: this.$ga,
          snackbar: {
            color: 'error',
            text: 'ユーザの削除に失敗しました',
          },
        });
      }
    },
  },
};
</script>
